import camelCase from 'lodash/camelCase';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { incidentExperimentTraitResource } from '@atlassian/jira-router-resources-software-incidents/src/services/index.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { forgeProjectModuleResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/forge/index.tsx';
import { staticSidebarShortcutsResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-sidebar-shortcuts/index.tsx';
import { staticProjectSidebarNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { softwareReportsDeploymentFrequencyClassicRoute } from '@atlassian/jira-router-routes-classic-projects-routes/src/softwareReportsDeploymentFrequencyClassicRoute.tsx';
import { isDevopsFeatureDisabledInFedRamp } from '@atlassian/jira-software-devops-fedramp-utils/src/index.tsx';
import { genericProjectLayout } from '@atlassian/jira-generic-project-layout/src/index.tsx';
import { classicBoardSidebars } from '@atlassian/jira-navigation-apps-sidebar-generic-sidebars/src/ui/index.tsx';
import { devOpsProviderResource } from '@atlassian/jira-router-resources-devops-provider/src/services/index.tsx';
import { isFedRamp } from '@atlassian/atl-context';
import { notFoundPageEntrypoint } from '@atlassian/jira-router-routes-not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import {
	DeploymentFrequencyReportClassic,
	LazyDeploymentFrequencyReport,
} from './ui/software/reports/deployment-frequency/index-old.tsx';
import { getReportsCommonResource } from './common/ui/resources/reports/index.tsx';
import {
	deploymentFrequencyReportPageEntrypointOld,
	deploymentFrequencyReportPageEntrypoint,
} from './ui/software/reports/deployment-frequency/index.tsx';

export const softwareReportsDeploymentFrequencyClassicRouteEntry = createEntry(
	softwareReportsDeploymentFrequencyClassicRoute,
	() => ({
		group: 'classic-software',

		component: componentWithCondition(
			isDevopsFeatureDisabledInFedRamp,
			ErrorPagesNotFound,
			DeploymentFrequencyReportClassic,
		),

		entryPoint: () => {
			if (isFedRamp()) {
				return notFoundPageEntrypoint;
			}
			return fg('jfp-magma-sidenav-cmp-ssr')
				? deploymentFrequencyReportPageEntrypoint
				: deploymentFrequencyReportPageEntrypointOld;
		},

		layout: genericProjectLayout,

		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: classicBoardSidebars,
			sidebarId: fg('jfp-magma-sidenav-cmp-ssr') ? SIDEBAR_ID.CONTENT : undefined,
		},

		resources: [
			...getNavigationResources({
				isUsingSidebarEntrypoint: fg('jfp-magma-sidenav-cmp-ssr'),
			}),
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
			incidentExperimentTraitResource,
			projectContextResource,
			forgeProjectModuleResource,
			staticSidebarShortcutsResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			// end of resources expanded from getNavigationSidebarProjectResource
			...getReportsCommonResource(),
			devOpsProviderResource,
		],

		afterPaint: [LazyDeploymentFrequencyReport],
		forPaint: [LazyAtlassianNavigation, LazyDeploymentFrequencyReport],

		preloadOptions: {
			earlyChunks: ['rapidboard-early-entry'],
		},

		meta: {
			reporting: {
				id: 'software-reports-deployment-frequency-classic',
				packageName: camelCase('software-reports-deployment-frequency-classic'),
				teamName: 'fusion-solaris',
			},
		},

		supportsPreviewPanel: true,

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-classic-projects-entries/src/softwareReportsDeploymentFrequencyClassicRouteEntry.tsx',
				whichExportToUse: 'softwareReportsDeploymentFrequencyClassicRouteEntry',
			},

			enabled: true,
		},
	}),
);
